<div class="zci-what-would-you-like-to-do-banner c11n-space-stack-4x">
    <h2 class="zci-what-would-you-like-to-do-banner__heading c11n-text-lg-headline">{{ content?.heading }}</h2>
    <div class="zci-what-would-you-like-to-do-banner__actions">
        <c11n-button
            buttonType="button"
            size="medium"
            variant="secondary"
            [labelText]="content?.grantNewAccessButton"
            [fullWidth]="isMobileView$ | async"
            data-cy="grant-new-access-button"
            (clickEvent)="onGrantAccessClick()"
        ></c11n-button>
        <c11n-button
            *ngIf="hasAnyGrantees$ | async"
            buttonType="button"
            size="medium"
            variant="secondary"
            [labelText]="content?.removeAccessButton"
            [fullWidth]="isMobileView$ | async"
            data-cy="remove-access-button"
            (clickEvent)="onRemoveAccessClick()"
        ></c11n-button>
    </div>
</div>
